interface TextSegment {
  text: string
  isBoldText?: boolean
}

export const formatAndCombineTextArray = (textArray: TextSegment[], replacements?: Record<string, string>) =>
  textArray.map((item, index) => {
    let processedText = item.text

    if (replacements) {
      Object.entries(replacements).forEach(([key, value]) => {
        processedText = processedText.replaceAll(key, value)
      })
    }

    return item.isBoldText ? <strong key={index}>{processedText}</strong> : processedText
  })
